export const EMPLOYEE_RENTALS_CARD = 'EMPLOYEE_RENTALS_CARD'
export const EMPLOYEE_PHONE_PLANS = 'EMPLOYEE_PHONE_PLANS'
export const EMPLOYEE_RECENT_REQUESTS = 'EMPLOYEE_RECENT_REQUESTS'
